/* eslint-disable @typescript-eslint/no-explicit-any */
import { browser } from '$app/environment';
import { NativeBridge } from './native-bridge';

// note: the presence of the 'window.native' object indicates that we are running inside a native app
// https://casumo.atlassian.net/wiki/spaces/PCN/pages/27184922743/Native+Bridge+Documentation
const isNative = () => browser && !!window.native;

let nativeBridgeInstance: NativeBridge | null = null;

export const initNativeBridge = (): NativeBridge | null => {
    if (!isNative() || nativeBridgeInstance) {
        return nativeBridgeInstance;
    }

    nativeBridgeInstance = new NativeBridge();
    return nativeBridgeInstance;
};

export const emitNavigateToNativeLogin = () => {
    nativeBridgeInstance?.sendMessageToNative('goToNativeLogin', {});
};

export const sendRegistrationStartNativeEvents = () => {
    if (!nativeBridgeInstance) return;
    // Send Navitive events.
    nativeBridgeInstance.sendMessageToNative('appLoaded', { isLoggedIn: false });
    nativeBridgeInstance.sendMessageToNative('onRouteLoaded', {
        isLoggedIn: false,
        id: window?.location?.pathname
    });
    nativeBridgeInstance.sendMessageToNative('onRouteChanged', {
        isLoggedIn: false,
        id: window?.location?.pathname
    });
};

export const sendRegistrationEndNativeEvent = (
    userId: string | undefined,
    selectedWelcomeOfferId: string | undefined
): void => {
    // Send Navitive events.
    nativeBridgeInstance?.sendMessageToNative('playerRegistered', {
        selectedWelcomeOfferId,
        userId
    });
};

export const onRegistrationComplete = ({
    userId,
    regilyData,
    apiData: _
}: {
    userId: string;
    regilyData?: {
        user?: {
            selectedBonus: string;
        };
    };
    apiData: unknown;
}) => {
    nativeBridgeInstance?.sendMessageToNative('playerRegistered', {
        selectedWelcomeOfferId: regilyData?.user?.selectedBonus,
        userId
    });
};
